import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import useMediaQuery from "@mui/material/useMediaQuery";

import { LEGEND_VALUES } from "constants/audiogram";

import PureToneAudiogramLegendItem from "./pure-tone-audiogram-legend-item.component";

export default function PureToneAudiogramLegend() {
  const isLargeScreen = useMediaQuery("(min-width:1700px)");
  return (
    <Stack
      direction="row"
      data-testid="pure-tone-audiogram-legend"
      justifyContent="center"
      spacing={isLargeScreen ? 3 : 2}
      sx={{
        boxSizing: "border-box",
        width: "100%",
        borderTop: "1px solid #CFCFCF",
        borderBottom: "1px solid #CFCFCF",
        position: "relative",
        flexWrap: "wrap",
        mb: 2,
        py: 1,
        px: 1
      }}
    >
      {LEGEND_VALUES.getOptions().map(({ label, value }, index) => {
        return (
          <React.Fragment key={label}>
            {value === "A" && (
              <Box sx={{ flexBasis: "100%", height: 0, pb: 3 }} />
            )}
            <PureToneAudiogramLegendItem label={label} value={value} />
          </React.Fragment>
        );
      })}
    </Stack>
  );
}
